<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Category"
      text="Edit Job Category"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localJobCategory.name"
                v-validate="'required'"  
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"  
          class="px-10 white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      jobCategory: {
        type: Object,
        default: null,
      },  
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localJobCategory: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.localJobCategory = { ...this.jobCategory }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.jobCategories().update(this.localJobCategory.id, { name: this.localJobCategory.name })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
